import {InformationCircleIcon} from "@heroicons/react/24/outline";
import Dropdown from "../../../general/Dropdown.tsx";
import {fieldLabelClasses} from "../../../general/fieldStyles.ts";
import {DEFAULT_CURRENCY} from "../../../../types/constants.ts";
import type { CurrencyEnum } from '../../../../generated/enums.ts';

interface CurrencyFieldProps {
    selectedCurrency: CurrencyEnum;
    options: CurrencyEnum[];
    onChange: (currency: CurrencyEnum) => void;
    showMultiCurrencyBanner?: boolean;
}

export function CurrencyField({
    selectedCurrency,
    options,
    onChange,
    showMultiCurrencyBanner = false,
}: CurrencyFieldProps) {
    return (
        <div className="flex flex-col gap-1.5">
            <span className={fieldLabelClasses}>Valuta</span>
            <div className="flex items-center gap-2">
                <div className="w-[5.5rem] min-w-[5.5rem]">
                    <Dropdown
                        selected={{
                            value: selectedCurrency || DEFAULT_CURRENCY,
                            label: selectedCurrency || DEFAULT_CURRENCY,
                        }}
                        options={options.map((curr) => ({value: curr, label: curr}))}
                        onUpdateFunc={(value) => onChange(value as CurrencyEnum)}
                    />
                </div>
                {showMultiCurrencyBanner && (
                    <span className="flex items-center gap-1.5 rounded-md border border-primary/20 bg-superliteprimary px-2.5 py-2 text-xs text-gray-700">
                        <InformationCircleIcon className="h-4 w-4 shrink-0" />
                        Meerdere valuta
                    </span>
                )}
            </div>
        </div>
    );
}
